type Props = {
    title: string,
    content: any
}

export function SimpleModal({ title, content }: Props) {
    return <div className="modal-content">
        <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
        </div>
        <div className="modal-body">
            {content}
        </div>
    </div>
}